import { motion } from "framer-motion";

// Section reveal wrapper
export const Reveal = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for headings (array of lines)
export const MaskLines = ({ lines, className = "", start = 0.2 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{
            duration: 0.9,
            delay: start + i * 0.15,
            ease: [0.16, 1, 0.3, 1],
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export default Reveal;
